import React, { useState, useEffect, useRef } from 'react';

const FadeInImage = ({
  src,
  alt,
  className = '',
  width,
  height,
  loading = 'lazy',
  fetchpriority,
  showSkeleton = true,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    if (!loading || loading === 'eager' || fetchpriority === 'high') {
      // For eager loading images, don't wait for intersection
      setIsInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '50px' }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, [loading, fetchpriority]);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className={`relative ${className}`} style={{ width, height }}>
      {/* Skeleton loader */}
      {showSkeleton && !isLoaded && (
        <div
          className="absolute inset-0 skeleton rounded-lg"
          style={{ width, height }}
        />
      )}

      {/* Actual image */}
      <img
        ref={imgRef}
        src={isInView ? src : undefined}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        fetchpriority={fetchpriority}
        onLoad={handleLoad}
        className={`${className} media-fade-in ${isLoaded ? 'loaded' : ''}`}
        style={{
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.6s ease-out',
          width,
          height
        }}
        decoding="async"
        {...props}
      />
    </div>
  );
};

export default FadeInImage;